import { createAsyncThunk } from '@reduxjs/toolkit';
import { getNerobottiThreads } from '../services/getNerobottiThreads';

/**
 * Load a page of the conversation list.
 *
 * Called with no argument for the first page and with the previous response's
 * `cursor` for the next. `append` travels back to the reducer because only the
 * caller knows which of the two this was — the response looks the same either
 * way, and a fulfilled action that cannot tell them apart would either
 * duplicate the first page or drop it.
 */
export const fetchNerobottiThreads = createAsyncThunk(
    'nerobotti/fetchThreads',
    async ({ cursor } = {}) => {
        const data = await getNerobottiThreads({ cursor });

        return {
            threads: Array.isArray(data?.threads) ? data.threads : [],
            // Absent means the end of the list, which the reducer stores as
            // null so "no more pages" is a value rather than a missing key.
            cursor: data?.cursor ?? null,
            append: Boolean(cursor),
        };
    }
);

export default fetchNerobottiThreads;
